var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.054 52c0 21.017-17.037 38.054-38.054 38.054-21.017 0-38.055-17.037-38.055-38.054 0-21.017 17.038-38.055 38.055-38.055S90.054 30.983 90.054 52z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.055 54.483c0 19.646-15.926 35.572-35.572 35.572S18.91 74.13 18.91 54.483 34.837 18.91 54.483 18.91s35.572 15.927 35.572 35.573z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.758 35.209c.7-1.37 2.133-2.236 3.7-2.236H56.89c1.567 0 2.999.865 3.7 2.236l2.993 5.852h8.273c2.284 0 4.136 1.811 4.136 4.045v20.222a4.008 4.008 0 0 1-1.63 3.217l-11.606.828H30.491c-2.285 0-4.137-1.811-4.137-4.045V45.106c0-2.234 1.852-4.044 4.137-4.044h4.136l7.13-5.853zm23.48 11.827c0-.913.74-1.654 1.654-1.654h2.482a1.654 1.654 0 1 1 0 3.309h-2.482c-.914 0-1.655-.74-1.655-1.655zM51.173 62.754c5.482 0 9.927-4.444 9.927-9.927 0-5.482-4.445-9.927-9.927-9.927-5.483 0-9.928 4.445-9.928 9.927 0 5.483 4.445 9.927 9.928 9.927z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.763 22.913A37.07 37.07 0 0 1 52 14.773c20.56 0 37.227 16.667 37.227 37.227a37.07 37.07 0 0 1-8.14 23.237L28.763 22.914zm-5.85 5.85A37.07 37.07 0 0 0 14.773 52c0 20.56 16.667 37.227 37.227 37.227a37.07 37.07 0 0 0 23.237-8.14L22.914 28.763zM52 6.5C26.871 6.5 6.5 26.871 6.5 52S26.871 97.5 52 97.5 97.5 77.129 97.5 52 77.129 6.5 52 6.5z",
    fill: "#FF4545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCamera);
export default __webpack_public_path__ + "static/media/no-camera.c8c5131028c663862eccfaba96c803ac.svg";
export { ForwardRef as ReactComponent };